import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { formatCurrencyManual } from "../../utils/formatters";
import { FormCard, Field, TextInput } from "../../components/ui/form";
import { Num } from "../../components/ui";
import { tokens } from "../../theme";

/** Dato del cliente: etiqueta chica arriba, valor abajo. Apila solo en teléfono. */
const ClientFact = ({ label, children, numeric }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
    <Typography sx={{ fontSize: "11.5px", fontWeight: 500, color: tokens.ink3 }}>
      {label}
    </Typography>
    {numeric ? (
      <Num sx={{ fontSize: "14px", fontWeight: 600 }}>{children}</Num>
    ) : (
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {children}
      </Typography>
    )}
  </Box>
);

const HeadPayment = ({ client, disableEdition, setPaymentDescription, updatedBalance }) => {
  const [description, setDescription] = useState('');

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescription(value);
    setPaymentDescription(value);
  };

  // Usar el saldo actualizado si está disponible, de lo contrario usar el saldo del cliente
  const displayBalance = updatedBalance !== undefined ? updatedBalance : (client ? client.balance : 0);

  return (
    <FormCard title="Recibo" subtitle="Datos del cliente" sx={{ width: "100%", minWidth: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(auto-fit, minmax(190px, 1fr))" },
          gap: { xs: "12px", md: "16px" },
          paddingBottom: "14px",
          borderBottom: `1px solid ${tokens.border}`,
        }}
      >
        <ClientFact label="Cliente">{client ? client.company : 'No disponible'}</ClientFact>
        <ClientFact label="CUIT" numeric>{client ? client.cuit : 'No disponible'}</ClientFact>
        <ClientFact label="Saldo disponible" numeric>{formatCurrencyManual(displayBalance)}</ClientFact>
      </Box>

      <Field label="Observaciones">
        <TextInput
          type="text"
          disabled={disableEdition}
          value={description}
          id="paymentDescription"
          placeholder="Referencia del pago, número de recibo, notas…"
          onChange={handleDescriptionChange}
        />
      </Field>
    </FormCard>
  );
};

export default HeadPayment;
